import { ListenerMiddlewareInstance } from '@reduxjs/toolkit';

import { applyAuthListeners } from '@/shared/authentication';

export function registerListeners(listenerMiddleware: ListenerMiddlewareInstance) {
  applyAuthListeners(listenerMiddleware);
}
